import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function QuoteForm() {
  const [form, setForm] = useState({ company_name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/quotes", form);
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not submit");
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center py-10" data-testid="quote-success-message">
        <CheckCircle2 className="h-12 w-12 text-teal-500 mx-auto" />
        <h3 className="font-display text-2xl font-medium mt-4 text-[#0a2540]">Thank you!</h3>
        <p className="text-slate-600 mt-2 max-w-sm mx-auto">
          Somebody from our team will get back to you shortly.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="quote-form">
      <div className="space-y-2">
        <Label htmlFor="q-company">Company name</Label>
        <Input id="q-company" required value={form.company_name}
          data-testid="quote-company-input"
          onChange={(e) => setForm({ ...form, company_name: e.target.value })}
          placeholder="Acme Health Systems" />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="q-email">Email address</Label>
          <Input id="q-email" type="email" required value={form.email}
            data-testid="quote-email-input"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="you@company.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="q-phone">Phone number</Label>
          <Input id="q-phone" type="tel" required value={form.phone}
            data-testid="quote-phone-input"
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            placeholder="+1 (555) 000-0000" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="q-message">Tell us about your needs (optional)</Label>
        <Textarea id="q-message" rows={3} value={form.message}
          data-testid="quote-message-input"
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          placeholder="Languages, call volume, hours…" />
      </div>
      <Button type="submit" disabled={busy}
        data-testid="quote-submit-btn"
        className="w-full rounded-full bg-yellow-400 text-[#0a2540] hover:bg-yellow-300 font-semibold h-12">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Request a quote"}
      </Button>
    </form>
  );
}
